var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sc-message--file", style: _vm.messageColors },
    [
      _c("div", { staticClass: "sc-message--file-icon" }, [
        _c("img", {
          staticClass: "sc-image",
          attrs: { src: _vm.data.file.url },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sc-message--file-name", style: _vm.messageColors },
        [
          _c(
            "a",
            {
              attrs: {
                href: _vm.data.file.url ? _vm.data.file.url : "#",
                target: "_blank",
              },
            },
            [_vm._v(_vm._s(_vm.data.file.name || ""))]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sc-message--file-text", style: _vm.messageColors },
        [
          _vm._v("\n        " + _vm._s(_vm.data.text) + "\n        "),
          _vm.data.meta
            ? _c(
                "p",
                { staticClass: "sc-message--meta", style: _vm.messageColors },
                [
                  _vm._v(
                    "\n            " + _vm._s(_vm.data.meta) + "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }